import { createReducer } from '../../../utilities';
import {
    SUCCESS_FETCH_STATS_PLAYERS_GOALS
} from "../../../../actions/entities/statistics/players";

const initialState = {};

function successFetch(state, action) {
    const { data } = action;
    return {
        ...state,
        ...data,
    };
}

export default createReducer(initialState, {
    [SUCCESS_FETCH_STATS_PLAYERS_GOALS]: successFetch,
});



// WEBPACK FOOTER //
// ./src/reducers/app/statistics/players/goals.js